import React from "react";
import moment from "moment";

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Icon,
  Content,
  CardTitle,
  BoxDesktop,
  BoxMobile,
  List, 
  Item,
  ContentStatus,
  StatusCollor,
  DivisionTitle,
  CardContainer
} from "./styles";
import trocaswhite from '~/assets/images/trocas_white.png';

export default function ModalDashboard({ 
  carnister,
  close
}) {

  const details = [
    {
      title: "Data de criação",
      content: carnister.processCreatedDate ? 
      moment(carnister.processCreatedDate, "YYYY-MM-DD").format("DD/MM/YYYY") : 
      ""
    },
    {
      title: "Recipiente",
      content: carnister.recipient
    },
    {
      title: "N° do lacre",
      content: carnister.sealNumber
    },
    {
      title: "Data da análise",
      content: carnister.analysisDate ? 
      moment(carnister.analysisDate, "YYYY-MM-DD").format("DD/MM/YYYY") :
      ""
    },
    {
      title: "Motivo da troca",
      content: carnister.exchangeReason
    },
    {
      title: "Motivo verificado",
      content: carnister.verifiedReason
    },
    {
      title: "Reposição realizada",
      content: carnister.isReplacementRealized ? "Sim" : "Não"
    },
    {
      title: "Nº do pedido",
      content: carnister.orderNumber
    },
    {
      title: "Data do pedido",
      content: carnister.orderDate ? 
      moment(carnister.orderDate, "YYYY-MM-DD").format("DD/MM/YYYY") : 
      ""
    }
  ]

  const StatusText = ({ status }) => {
    if (
      status === "PENDING_ANALYSIS"
    ) {
      return <span>AGUARDANDO ANÁLISE</span>
    } else if(status === "APPROVED") {
      return <span>APROVADO</span>
    } else if(status === "PENDING_APPROVAL") {
      return <span>AGUARDANDO APROVAÇÃO</span>;
    } else {
      return <span>REPROVADO</span>;
    }
  };

  return (
    <Container className="background">
      <BoxDesktop>
        {
          carnister ? (
            <>
              <Header>
                <Left>
                  <img src={trocaswhite} alt="Ícone de trocas" />
                  <Title>Trocas</Title>
                </Left>
                <CloseIcon
                  title="Fechar"
                  className="mdi mdi-close"
                  onClick={() => close()}
                />
              </Header>
              <Content>
                <DivisionTitle>
                  <CardTitle>Detalhes</CardTitle>
                  <ContentStatus>
                    <StatusCollor status={carnister.status}></StatusCollor>
                    <StatusText status={carnister.status} />
                  </ContentStatus>
                </DivisionTitle>
                <List>
                  {
                    details.map((item) => (
                      <Item>
                        <span>{item.title}: </span> {item.content}
                      </Item>
                    ))
                  }
                </List>
              </Content>
            </>
          ) : null
        }
      </BoxDesktop>
      <BoxMobile>
        <Header>
          <Left>
            <img src={trocaswhite} alt="Ícone de trocas" />
            <Title>Trocas</Title>
          </Left>
          <CloseIcon
            title="Fechar"
            className="mdi mdi-close"
            onClick={() => close()}
          />
        </Header>
        <CardContainer>
          {
            carnister ? (
              <>
                <Content>
                  <DivisionTitle>
                    <CardTitle>Detalhes</CardTitle>
                    <ContentStatus>
                      <StatusCollor status={carnister.status}></StatusCollor>
                      <StatusText status={carnister.status} />
                    </ContentStatus>
                  </DivisionTitle>
                  <List>
                    {
                      details.map((item) => (
                        <Item>
                          <span>{item.title}</span> 
                          <div>{item.content}</div>
                        </Item>
                      ))
                    }
                  </List>
                </Content>
              </>
            ) : null
          }
        </CardContainer>
      </BoxMobile>
    </Container>
  );
}
